/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApplyRequestInput,
  ApprovalReviewInput,
  CancelApprovalRequestInput,
  CreateApprovalRequestInput,
  GetApiUserManagementV1ApprovalRequestsParams,
  ProblemDetails
} from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1ApprovalRequests = (
  params?: GetApiUserManagementV1ApprovalRequestsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/approval-requests`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1ApprovalRequestsQueryKey = (params?: GetApiUserManagementV1ApprovalRequestsParams) => {
  return [`/api/user-management/v1/approval-requests`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1ApprovalRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1ApprovalRequestsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1ApprovalRequestsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>> = ({ signal }) =>
    getApiUserManagementV1ApprovalRequests(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1ApprovalRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>
>;
export type GetApiUserManagementV1ApprovalRequestsQueryError = unknown;

export function useGetApiUserManagementV1ApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
  TError = unknown
>(
  params: undefined | GetApiUserManagementV1ApprovalRequestsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1ApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1ApprovalRequestsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1ApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1ApprovalRequestsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1ApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1ApprovalRequestsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequests>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1ApprovalRequestsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1ApprovalRequests = (
  createApprovalRequestInput: CreateApprovalRequestInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/approval-requests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createApprovalRequestInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1ApprovalRequestsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequests>>,
    TError,
    { data: CreateApprovalRequestInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequests>>,
  TError,
  { data: CreateApprovalRequestInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1ApprovalRequests'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequests>>,
    { data: CreateApprovalRequestInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUserManagementV1ApprovalRequests(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1ApprovalRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequests>>
>;
export type PostApiUserManagementV1ApprovalRequestsMutationBody = CreateApprovalRequestInput;
export type PostApiUserManagementV1ApprovalRequestsMutationError = unknown;

export const usePostApiUserManagementV1ApprovalRequests = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequests>>,
      TError,
      { data: CreateApprovalRequestInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequests>>,
  TError,
  { data: CreateApprovalRequestInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1ApprovalRequestsMutationOptions(options), queryClient);
};
export const getApiUserManagementV1ApprovalRequestsSummary = (options?: SecondParameter<typeof axiosInstance>, signal?: AbortSignal) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/approval-requests/summary`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1ApprovalRequestsSummaryQueryKey = () => {
  return [`/api/user-management/v1/approval-requests/summary`] as const;
};

export const getGetApiUserManagementV1ApprovalRequestsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
  TError = unknown
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>, TError, TData>>;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1ApprovalRequestsSummaryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>> = ({ signal }) =>
    getApiUserManagementV1ApprovalRequestsSummary(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1ApprovalRequestsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>
>;
export type GetApiUserManagementV1ApprovalRequestsSummaryQueryError = unknown;

export function useGetApiUserManagementV1ApprovalRequestsSummary<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
  TError = unknown
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1ApprovalRequestsSummary<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
  TError = unknown
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1ApprovalRequestsSummary<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
  TError = unknown
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1ApprovalRequestsSummary<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>,
  TError = unknown
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1ApprovalRequestsSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1ApprovalRequestsRequestId = (
  requestId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/approval-requests/${requestId}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1ApprovalRequestsRequestIdQueryKey = (requestId: number) => {
  return [`/api/user-management/v1/approval-requests/${requestId}`] as const;
};

export const getGetApiUserManagementV1ApprovalRequestsRequestIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
  TError = unknown
>(
  requestId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1ApprovalRequestsRequestIdQueryKey(requestId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>> = ({ signal }) =>
    getApiUserManagementV1ApprovalRequestsRequestId(requestId, requestOptions, signal);

  return { queryKey, queryFn, enabled: requestId !== null && requestId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1ApprovalRequestsRequestIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>
>;
export type GetApiUserManagementV1ApprovalRequestsRequestIdQueryError = unknown;

export function useGetApiUserManagementV1ApprovalRequestsRequestId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
  TError = unknown
>(
  requestId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1ApprovalRequestsRequestId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
  TError = unknown
>(
  requestId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1ApprovalRequestsRequestId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
  TError = unknown
>(
  requestId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1ApprovalRequestsRequestId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>,
  TError = unknown
>(
  requestId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1ApprovalRequestsRequestId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1ApprovalRequestsRequestIdQueryOptions(requestId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1ApprovalRequestsRequestIdApprove = (
  requestId: number,
  approvalReviewInput: ApprovalReviewInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/approval-requests/${requestId}/approve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: approvalReviewInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1ApprovalRequestsRequestIdApproveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApprove>>,
    TError,
    { requestId: number; data: ApprovalReviewInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApprove>>,
  TError,
  { requestId: number; data: ApprovalReviewInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1ApprovalRequestsRequestIdApprove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApprove>>,
    { requestId: number; data: ApprovalReviewInput }
  > = (props) => {
    const { requestId, data } = props ?? {};

    return postApiUserManagementV1ApprovalRequestsRequestIdApprove(requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1ApprovalRequestsRequestIdApproveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApprove>>
>;
export type PostApiUserManagementV1ApprovalRequestsRequestIdApproveMutationBody = ApprovalReviewInput;
export type PostApiUserManagementV1ApprovalRequestsRequestIdApproveMutationError = unknown;

export const usePostApiUserManagementV1ApprovalRequestsRequestIdApprove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApprove>>,
      TError,
      { requestId: number; data: ApprovalReviewInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApprove>>,
  TError,
  { requestId: number; data: ApprovalReviewInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1ApprovalRequestsRequestIdApproveMutationOptions(options), queryClient);
};
export const postApiUserManagementV1ApprovalRequestsRequestIdReject = (
  requestId: number,
  approvalReviewInput: ApprovalReviewInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/approval-requests/${requestId}/reject`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: approvalReviewInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1ApprovalRequestsRequestIdRejectMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdReject>>,
    TError,
    { requestId: number; data: ApprovalReviewInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdReject>>,
  TError,
  { requestId: number; data: ApprovalReviewInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1ApprovalRequestsRequestIdReject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdReject>>,
    { requestId: number; data: ApprovalReviewInput }
  > = (props) => {
    const { requestId, data } = props ?? {};

    return postApiUserManagementV1ApprovalRequestsRequestIdReject(requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1ApprovalRequestsRequestIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdReject>>
>;
export type PostApiUserManagementV1ApprovalRequestsRequestIdRejectMutationBody = ApprovalReviewInput;
export type PostApiUserManagementV1ApprovalRequestsRequestIdRejectMutationError = unknown;

export const usePostApiUserManagementV1ApprovalRequestsRequestIdReject = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdReject>>,
      TError,
      { requestId: number; data: ApprovalReviewInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdReject>>,
  TError,
  { requestId: number; data: ApprovalReviewInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1ApprovalRequestsRequestIdRejectMutationOptions(options), queryClient);
};
export const postApiUserManagementV1ApprovalRequestsRequestIdCancel = (
  requestId: number,
  cancelApprovalRequestInput: CancelApprovalRequestInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/approval-requests/${requestId}/cancel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cancelApprovalRequestInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1ApprovalRequestsRequestIdCancelMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdCancel>>,
    TError,
    { requestId: number; data: CancelApprovalRequestInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdCancel>>,
  TError,
  { requestId: number; data: CancelApprovalRequestInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1ApprovalRequestsRequestIdCancel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdCancel>>,
    { requestId: number; data: CancelApprovalRequestInput }
  > = (props) => {
    const { requestId, data } = props ?? {};

    return postApiUserManagementV1ApprovalRequestsRequestIdCancel(requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1ApprovalRequestsRequestIdCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdCancel>>
>;
export type PostApiUserManagementV1ApprovalRequestsRequestIdCancelMutationBody = CancelApprovalRequestInput;
export type PostApiUserManagementV1ApprovalRequestsRequestIdCancelMutationError = ProblemDetails;

export const usePostApiUserManagementV1ApprovalRequestsRequestIdCancel = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdCancel>>,
      TError,
      { requestId: number; data: CancelApprovalRequestInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdCancel>>,
  TError,
  { requestId: number; data: CancelApprovalRequestInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1ApprovalRequestsRequestIdCancelMutationOptions(options), queryClient);
};
export const postApiUserManagementV1ApprovalRequestsRequestIdApply = (
  requestId: number,
  applyRequestInput: ApplyRequestInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/approval-requests/${requestId}/apply`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: applyRequestInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1ApprovalRequestsRequestIdApplyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApply>>,
    TError,
    { requestId: number; data: ApplyRequestInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApply>>,
  TError,
  { requestId: number; data: ApplyRequestInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1ApprovalRequestsRequestIdApply'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApply>>,
    { requestId: number; data: ApplyRequestInput }
  > = (props) => {
    const { requestId, data } = props ?? {};

    return postApiUserManagementV1ApprovalRequestsRequestIdApply(requestId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1ApprovalRequestsRequestIdApplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApply>>
>;
export type PostApiUserManagementV1ApprovalRequestsRequestIdApplyMutationBody = ApplyRequestInput;
export type PostApiUserManagementV1ApprovalRequestsRequestIdApplyMutationError = unknown;

export const usePostApiUserManagementV1ApprovalRequestsRequestIdApply = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApply>>,
      TError,
      { requestId: number; data: ApplyRequestInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1ApprovalRequestsRequestIdApply>>,
  TError,
  { requestId: number; data: ApplyRequestInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1ApprovalRequestsRequestIdApplyMutationOptions(options), queryClient);
};
